module.exports = __webpack_public_path__ + "/img/phone-icon.3257170414.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/phone-icon.png
// module id = 1393
// module chunks = 0